export const EDITOR_CONTAINER_SELECTORS = {
   CARD_HEADER: '.card-header',
   CARD_BODY: '.card-body',
   CARD_FOOTER: '.card-footer',
} as const;